import { StoreModalContainer } from './StoreModalContainer';
export default StoreModalContainer;
